import { useModuleName } from 'hooks';
import { MODULE_NAME } from 'modules/creative-library/config';

export const useIsCreativeLibraryModule = () => {
    const moduleName = useModuleName();
    return moduleName === MODULE_NAME;
};
